import * as React from 'react';

/**
 * Fabric UI
 */
import { Link } from '@fluentui/react/lib/Link';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react/lib/Callout';

const Tag = (props) => {
  const { tag } = props;
  const _tag = tag.name || tag;

  return (
    <TooltipHost
      content={_tag}
      directionalHint={DirectionalHint.rightTopEdge}
    >
      <Link
        href={`/Search/${_tag.substr(1)}`}
        className="tag"
      >
        {_tag.substring(0, 20)}
      </Link>
    </TooltipHost>
  );
}

export default Tag;